// extracted by mini-css-extract-plugin
export default {"categoriesSelector":"BulkManageCategoriesModal_categoriesSelector__fpLxC"};